import type {
    IsoAndUnixTimestamp} from "@@/shared/date-time/iso-and-unix";
import {
    isoAndUnixZodSchema,
    nowIsoAndUnix,
} from "@@/shared/date-time/iso-and-unix";
import { idZodSchema } from "@@/shared/id";
import type {
    ProviderId} from "@@/shared/providers/provider-id";
import {
    providerIdZodSchema,
} from "@@/shared/providers/provider-id";
import type { SectionGroupId } from "@@/shared/section-groups/section-group";
import { generateId } from "@@/utilities/generate-id";
import type { Except } from "type-fest";
import { z } from "zod";
import type { SectionId } from "../section";

type SectionRemoveCommand = {
    readonly _id: string;
    readonly _type: "SECTION_REMOVE_COMMAND";
    readonly _createdAt: IsoAndUnixTimestamp;
    readonly providerId: ProviderId;
    readonly sectionGroupId: SectionGroupId;
    // TODO: REMOVE ABOVE SECTION GROUP ID
    // TODO: LATER, CAUSE SECTIONS SHOULD BE ABLE TO APPEAR IN MULTIPLE
    // TODO: SECTION GROUPS LATER ON, NEEDS TO FIND ALL REFS NOT JUST
    // TODO: THIS QUICK FIX FOR PROVIDER REMOVE
    readonly sectionId: SectionId;
};

type FactoryParams = Except<
    SectionRemoveCommand,
    "_id" | "_type" | "_createdAt"
>;
const sectionRemoveCommandFactory = (params: FactoryParams) => {
    const sectionRemoveCommand: SectionRemoveCommand = {
        ...params,
        _id: generateId({ prefix: "section_remove_command__" }),
        _type: "SECTION_REMOVE_COMMAND",
        _createdAt: nowIsoAndUnix(),
    };
    return sectionRemoveCommand;
};

const sectionRemoveCommandZodSchema: z.ZodSchema<SectionRemoveCommand> =
    z.object({
        _id: idZodSchema,
        _type: z.literal("SECTION_REMOVE_COMMAND"),
        _createdAt: isoAndUnixZodSchema,
        providerId: providerIdZodSchema,
        sectionId: idZodSchema,
        sectionGroupId: idZodSchema,
    });

export {
    sectionRemoveCommandFactory as sectionRemoveCommandFactory,
    sectionRemoveCommandZodSchema,
};
export type {
    SectionRemoveCommand,
    FactoryParams as SectionRemoveCommandFactoryParams,
};
